import {
  UPLOAD_DYNAMIC_QUALITY_MAP_OPTIONS,
  UPLOAD_DYNAMIC_QUALITY_TYPE_SOURCE,
} from 'consts/common'

export function getDynamicCompressQuality(input: File | Blob) {
  const typeSource = UPLOAD_DYNAMIC_QUALITY_TYPE_SOURCE[input.type]

  if (!typeSource) return 1

  const {
    sizeUpperLimitMB,
    sizeLowerLimitMB,
    maxQuality,
    minQuality,
  } = UPLOAD_DYNAMIC_QUALITY_MAP_OPTIONS[typeSource]

  const sizeMB = input.size / 1e6
  const sizeMBExtra = Math.max(0, sizeMB - sizeLowerLimitMB)
  const sizeMBRange = sizeUpperLimitMB - sizeLowerLimitMB

  /**
   * Size has an extra +1 because the log value starts at 1.
   * The base factor is already calculated with an additional 1MB.
   * At first, the quality rate will decline, but the change becomes smaller as the size increases.
   */
  const qualityDropRate = Math.min(
    1,
    Math.log(sizeMBExtra + 1) / Math.log(sizeMBRange + 1),
  )
  const qualityDropMax = maxQuality - minQuality
  const qualityDrop = qualityDropMax * qualityDropRate

  const quality = maxQuality - qualityDrop

  return quality
}
